const isISO8601 = (date) => {
  const isoDate = Date.parse(date);
  return !isNaN(isoDate) && !date.includes(" ");
};
const isRFC1123GTM = (date) => {
  return date.endsWith("GMT");
};
const isRFC1123 = (date) => {
  const rfcDate = new Date(date);
  return !isNaN(rfcDate.getTime());
};
const formatDateToTheSameStandardFormat = (date, formattedString) => {
  if (isRFC1123GTM(formattedString)) {
    return date.toUTCString();
  }
  if (isISO8601(formattedString)) {
    return date.toISOString();
  }
  if (isRFC1123(formattedString)) {
    return date.toString();
  }
  return null;
};
export {
  formatDateToTheSameStandardFormat as f
};
//# sourceMappingURL=parse-date.js.map
